import { Box, CTALink, Heading, Stack } from '@99designs/emu';
import { DesignInspiration } from '@99designs/feature-design-inspiration';
import { formatMessage } from '@99designs/frontend-components/i18n';
import { GridLayout } from '@99designs/marketing-ui';
import { Desktop, Mobile } from '@99designs/marketing-ui';
import { trackLink } from '../../lib/tracking';
import type { Design } from '@99designs/feature-design-inspiration';

type Props = {
    designOutcome: string;
    categoryKeys: string[];
    designs: Design[];
    productNameForTracking?: string;
    productIdForTracking?: string;
};

export function Inspiration({
    designOutcome,
    categoryKeys,
    designs,
    productNameForTracking,
    productIdForTracking,
}: Props) {
    const inspirationUrl = getDiscoverUrl(categoryKeys);

    return (
        <Stack space={['0.5bu', '0.5bu', '1bu', '1bu']}>
            <GridLayout>
                <Box display="flex" justifyContent="space-between" flexWrap="wrap">
                    <Box paddingRight="1bu" paddingBottom={['none', 'none', '0.5bu', '0.5bu']}>
                        <Heading appearanceLevel={3} accessibilityLevel={2}>
                            {formatMessage(__('{designOutcome} created on 99designs'), {
                                designOutcome,
                            })}
                        </Heading>
                    </Box>
                    <Desktop>
                        <InspirationLink
                            url={inspirationUrl}
                            productNameForTracking={productNameForTracking}
                            productIdForTracking={productIdForTracking}
                        />
                    </Desktop>
                </Box>
            </GridLayout>
            <DesignInspiration designs={designs} />
            <GridLayout>
                <Mobile>
                    <InspirationLink
                        url={inspirationUrl}
                        productNameForTracking={productNameForTracking}
                        productIdForTracking={productIdForTracking}
                    />
                </Mobile>
            </GridLayout>
        </Stack>
    );
}

interface InspirationLinkProps {
    url: string;
    productNameForTracking?: string;
    productIdForTracking?: string;
}

function InspirationLink({
    url,
    productNameForTracking = '',
    productIdForTracking = '',
}: InspirationLinkProps) {
    return (
        <CTALink
            href={url}
            onClick={(event) =>
                trackLink(event, 'See more inspiration on Product details page clicked', {
                    category: 'Product Page',
                    label: 'Content:Inspirations',
                    eventDetail: `/design/${productNameForTracking};https://99designs.com/discover;Inspirations;See more inspiration`,
                    navigationDetail: 'See more inspiration',
                    pageName: `${productIdForTracking}:Product Page`,
                    pageStage: 'Discover',
                    pageSection: 'Product Page',
                    pageDept: 'Design Services',
                })
            }
        >
            {__('See more inspiration')}
        </CTALink>
    );
}

function getDiscoverUrl(categoryKeys: string[]): string {
    const categoryKeysParams = categoryKeys.join(',');
    return `/discover?category=${categoryKeysParams}`;
}
